module.exports = __webpack_public_path__ + "media/images/emblems/Fehren-blason-2c539278cf890c0633487e66a8830089.png";